import {track as trackMossAnalytics} from '@getmoss/moss-analytics'
import type {ImageField, LinkField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import dynamic from 'next/dynamic'
import {useGetDomainCountry} from 'src/common/hooks/useGetDomainCountry'
import {Icon} from 'src/common/Icon'

const VideoPlayer = dynamic(() => import('src/common/VideoPlayer').then((mod) => mod.VideoPlayer), {ssr: false})

type DrawerVideoProps = {
  video_source?: LinkField
  fallback_image: ImageField
  pageUid?: string
  componentName?: string
  drawerTitle?: string
}

export const DrawerVideo = ({
  video_source,
  fallback_image,
  pageUid = '',
  componentName = '',
  drawerTitle = 'unknown',
}: DrawerVideoProps) => {
  const domainCountry = useGetDomainCountry()
  const videoSrc = isFilled.link(video_source) ? video_source.url : ''

  if (!videoSrc) {
    return null
  }

  const handlePlayClick = () => {
    trackMossAnalytics({
      event: 'interaction',
      interaction: {
        element: `DrawerVideo-${drawerTitle}`,
        elementText: 'play-button',
        location: `stresstimonials-drawer-video`,
        type: 'click',
      },
      page: {
        domainCountry,
        type: 'stresstimonials',
      },
    })
  }

  return (
    <div className="w-full">
      <VideoPlayer
        src={videoSrc}
        fallbackImg={fallback_image}
        playIcon={
          <div
            onClick={handlePlayClick}
            className="flex size-14 items-center justify-center rounded-full bg-green-neon transition-transform hover:scale-110"
          >
            <Icon name="play" className="size-6 text-moss-black" />
          </div>
        }
        pageUid={pageUid}
        location={componentName}
        className="rounded"
        startMuted={false}
      />
    </div>
  )
}
